import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import CoverImage from "../components/icons/CoverImage";
import Logo from "../components/icons/Logo";
import OTPInput from "../components/OTPInput/Index";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Verification = () => {
  const { resendVerificationMail, timeActive, setTimeActive, user, logout } = useAuth();
  const [time, setTime] = useState(60);

  const navigate = useNavigate();
  const submitHandler = (values) => {
    // navigate("/feed");
  };
  useEffect(() => {
    let interval = null;
    if (timeActive && time !== 0) {
      interval = setInterval(() => {
        setTime((time) => time - 1);
      }, 1000);
    } else if (time === 0) {
      setTimeActive(false);
      setTime(60);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timeActive, time, setTimeActive]);

  useEffect(() => {
    const interval = setInterval(() => {
      user
        ?.reload()
        .then(() => {
          if (user?.emailVerified) {
            clearInterval(interval);
            logout()
            navigate("/feed");
          }
        })
        .catch((err) => {
          alert(err.message);
        });
    }, 1000);
  }, [navigate, user, logout]);

  useEffect(() => {
    if (user?.emailVerified) {
      navigate("/feed");
    }
  }, [navigate, user]);

  return (
    <div className="flex w-full min-h-screen overflow-hidden md:h-screen">
      <CoverImage />
      <div className="flex items-center justify-between py-12 flex-col w-full md:w-[50%]">
        <div className="hidden md:block">
          <Logo />{" "}
        </div>
        <div className="w-full h-full flex flex-col items-center justify-center overflow-scroll">
          <div className="md:hidden  mb-12 ">
            <Logo />{" "}
          </div>
          <div className="w-[210px] md:w-[420px]">
            <h2 className="font-bold text-[28px] md:text-[36px]  text-[#1A1D4D]">Two Factor Authentication Code</h2>
            <p className="mt-2 text-[12px] md:w-[306px]">Check your personal Mail. We have sent you the pin at ******mail@gmail.com</p>
            <Formik onSubmit={submitHandler} initialValues={{}} validationSchema={""}>
              {({ handleSubmit }) => (
                <div className="w-full flex flex-col items-center justify-center ">
                  <div className="pt-6 w-[210px] md:w-[420px]">
                    <OTPInput
                      autoFocus
                      isNumberInput
                      length={5}
                      className="mb-[1.46rem] flex items-center  justify-start"
                      inputClassName=" border-b-2 text-[0.78125rem] font-normal outline-none text-center w-[32px]  md:w-[58px] text-4xl mr-[0.83rem]"
                      onChangeOTP={(otp) => null}
                    />
                  </div>

                  <button
                    className={`text-[12px] md:text-base font-semibold ${timeActive ? "text-gray-500" : "text-primary"} mt-[40px] self-start`}
                    onClick={resendVerificationMail}
                    disabled={timeActive}
                  >
                    Resend Code? <span className="text-black ml-2">{timeActive && `00:${time}`}</span>{" "}
                  </button>
                  <button
                    onClick={handleSubmit}
                    className="w-[210px] md:w-[337px] h-[50px] bg-primary rounded mt-[70px] text-white text-base font-semibold"
                  >
                    Verify
                  </button>
                </div>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verification;
